import { trackGAEvent } from './gaTracking';
import { GA_TRACK_EVENTS_ACTIONS } from './constants';

const SKIN_BANNER_SELECTOR = 'iframe[id*="skin"]';

export function observeSkinBanner(): () => void {
  let tracked = false;

  const checkAndTrack = () => {
    const skinBannerElement = document.querySelector<HTMLElement>(SKIN_BANNER_SELECTOR);

    if (!tracked && skinBannerElement) {
      trackGAEvent(GA_TRACK_EVENTS_ACTIONS.SKIN_BANNER_EXPOSER);
      tracked = true;
      observer.disconnect();
    }
  };

  const observer = new MutationObserver(checkAndTrack);
  observer.observe(document.body, { childList: true, subtree: true });

  checkAndTrack();

  return () => observer.disconnect();
}
